import React, { useState } from "react";

import Form from "react-bootstrap/Form";

import Button from "react-bootstrap/Button";
import image from "../assets/Image/GMSDC_LOGO.png";
import "../ui-components/style.css"
var CryptoJS = require("crypto-js");

export default function Login() {

  const [values, setValues] = React.useState({
    email: '',
    otp: ''
  })
 
  const [validations, setValidations] = React.useState({
    email: '',
    otp: ''
  })

  const queryParams = new URLSearchParams(window.location.search)
  const data = queryParams.get("email")
  
  const validateAll = () => {
    const {  email, otp } = values
    const validations = { email: '', otp: '' }
    let isValid = true
    
    if (!otp) {
      validations.otp = 'Otp is required'
      isValid = false
    }
    
    if (otp && otp?.length < 3 || otp?.length > 8) {
      validations.otp = 'otp must contain 8 digits'
      isValid = false
    }
    
    if (!email) {
      validations.email = 'Email is required'
      isValid = false
    }
    
    if (email && !/\S+@\S+\.\S+/.test(email)) {
      validations.email = 'Email format must be as example@mail.com'
      isValid = false
    }
        
    if (!isValid) {
      setValidations(validations)
    }
    
    return isValid
  }

  const validateOne = (e) => {
    const { name } = e.target
    const value = values[name]
    let message = ''
    
    if (!value) {
      message = `${name} is required`
    }
    
    if (value && name === 'otp' && (value?.length < 3 || value?.length > 50)) {
      message = 'otp must contain 3 to 8 digits'
    }

    if (value && name === 'email' && !/\S+@\S+\.\S+/.test(value)) {
      message = 'Email format must be as example@mail.com'
    }
    
    setValidations({...validations, [name]: message })
  }
  
  const handleChange = (e) => {
    const { name, value } = e.target
    setValues({...values, [name]: value })
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    const isValid = validateAll()
    
    if (!isValid) {
      return false
    }

    alert(JSON.stringify(values))
  }
  
  const { email, otp } = values

  const { 
    email: emailVal, 
    otp: otpVal 
  } = validations

  const [encrptedData, setEncrptedData] = useState("");
  const [decrptedData, setDecrptedData] = useState("");

  const secretPass = "XkhZG4fW2t2W";
const text = "new"
  const encryptData = () => {
    

    setEncrptedData(data);
  };
  const new123 = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    secretPass
  ).toString();
  return (
    <div class="vh-100 d-flex justify-content-center align-items-center ">
      <div class="col-md-5 p-5 shadow-sm border rounded-5 border-primary bg-white">
        <h2 class="text-center mb-4 text-primary">
          <img
            src={image}
            width="auto"
            height="80px"
            className="d-inline-block align-top"
            alt="React Bootstrap logo"
          />
        </h2>
        <form method="post">
          <div class="mb-3">
            <label for="exampleInputEmail1" class="form-label">
              Email address
            </label>
            <input
              type="email"
              class="form-control border border-primary"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="email"
              value={email ? email : data } 
              onChange={handleChange}
              onBlur={validateOne}
            />
            <div className="error">{emailVal}</div>
          </div>
          <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label">
              OTP
            </label>
            <input
              type="text"
              class="form-control border border-primary"
              id="exampleInputPassword1"
              name="otp"
              value={otp} 
              onChange={handleChange}
              onBlur={validateOne}
            />
            <div className="error">{otpVal}</div>
          </div>
          <div class="d-grid">
            <button class="btn btn-primary" type="submit" onClick={handleSubmit}>
              Login
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
